export default {
  // example
  // todos(state) {
  //   return state.list
  // },
  nav(state) {
    return state.nav
  },
}
